import React, { useEffect, useState } from "react";
import TournamentCard from "../../components/cards/tournament.card.js";
import UserCard from "../../components/cards/user.card.js";
import { getActiveEvent, joinEvent, kickUser } from "../../api/event.api.js";
import { getEventTournaments } from "../../api/tournament.api.js";
import { getUsersLight } from "../../api/user.api.js";
import { Box, Button, Divider, Typography, Grid } from "@mui/material";
import moment from "moment";
import { useAuth } from "../../context/auth.context.js";
import emkay from "../../assets/emkay512.png";
import replugged from "../../assets/replugged512.png";
import Links from "../../components/util/links.component.js";
import { useWebSocket } from "../../context/websocket.context.js";
import { useSnackbar } from "../../context/snackbar.context.js";
import { getPolls } from "../../api/poll.api.js";
import PollCard from "../../components/cards/poll.card.js";
import { getRanking } from "../../api/ranking.api.js";
import RankingCard from "../../components/cards/ranking.card.js";
import { getAllOrders } from "../../api/order.api.js";
import OrderOverviewCard from "../../components/cards/orderOverview.card.js";
import { getAllGathers } from "../../api/gather.api.js";
import GatherCard from "../../components/cards/gather.card.js";

const DashboardPage = () => {
  const [event, setEvent] = useState();
  const [tournaments, setTournaments] = useState([]);
  const [gathers, setGathers] = useState([]);
  const [users, setUsers] = useState([]);
  const [polls, setPolls] = useState([]);
  const [ranking, setRanking] = useState();
  const [openOrders, setOpenOrders] = useState();
  const [refreshDashboard, setRefreshDashboard] = useState(false);
  const auth = useAuth();
  const [lastMessage, SetLastMessage] = useState();
  const websocket = useWebSocket();
  const showSnackbar = useSnackbar();

  useEffect(() => {
    if (!websocket || !websocket.message) {
      return;
    }
    if (JSON.stringify(websocket.message) === JSON.stringify(lastMessage)) {
      return;
    }
    if (
      websocket.message.Type === "Event" ||
      websocket.message.Type === "Tournament" ||
      websocket.message.Type === "Poll" ||
      websocket.message.Type === "Order" ||
      websocket.message.Type === "Ranking" ||
      websocket.message.Type === "Gather"
    ) {
      SetLastMessage(websocket.message);
      setRefreshDashboard((prev) => !prev);
    }
  }, [websocket]);

  useEffect(() => {
    if (!auth || !auth.user) { return; }
    getPolls().then((response) => {
      setPolls(
        response.data.sort((t1, t2) => {
          if (t1.status <= t2.status) {
            return 1;
          } else if (t1.status > t2.status) {
            return -1;
          }
          return 0;
        })
      );
    });
  }, [refreshDashboard, auth]);

  useEffect(() => {
    if (!auth || !auth.user) { return; }
    getActiveEvent()
      .then((response) => {
        setEvent(response.data);
        getEventTournaments(response.data.id)
          .then((response) => {
            setTournaments(
              response.data.sort((t1, t2) => {
                if (t1.status <= t2.status) {
                  return 1;
                } else if (t1.status > t2.status) {
                  return -1;
                }
                return 0;
              })
            );
          })
          .catch((e) => console.log(e));
        getUsersLight(response.data.participants)
          .then((response) => {
            setUsers(response.data);
          })
          .catch((e) => console.log(e));
        getRanking(response.data.id).then((response) => {
          setRanking(response.data);
        });
        getAllGathers(response.data.id).then((response) => {
          setGathers(response.data);
        });
      })
      .catch((e) => console.log(e));

    getAllOrders().then((response) => {
      setOpenOrders(response.data.filter((order) => order.status === "Open"));
    });
  }, [refreshDashboard, auth]);

  const isUserParticipant = () => {
    if (!event || !auth.user) {
      return false;
    }
    if (event.participants.includes(auth.user.id)) {
      return true;
    }
  };

  const handleJoin = () => {
    joinEvent(event.id, auth.user.id)
      .then(() => showSnackbar("Joined Event!", "success"))
      .catch(() => { });
  };

  const handleKick = (evnt, userId) => {
    if (evnt.ctrlKey) {
      evnt.stopPropagation();
      kickUser(userId)
        .then(() => showSnackbar("User kicked!", "success"))
        .catch(() => { });
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {event && (
        <Box flex="1" className="content-container">
          <Box sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center"
          }}>
            {event.imageName && (
              <Box
                component="img"
                sx={{
                  height: 200,
                  width: 400,
                  maxHeight: 200,
                  maxWidth: 400,
                  maskImage:
                    "linear-gradient(to right, transparent, black 30%, black 70%, transparent)",
                  WebkitMaskImage:
                    "linear-gradient(to right, transparent, black 30%, black 70%, transparent)",
                }}
                alt="header"
                src={`/static/images/${event.imageName}`}
              />
            )}
            <Box>
              <Typography variant="h3">{event.name}</Typography>
              <Typography
                sx={{ color: "text.secondary", mb: 1.5, fontSize: 12 }}
              >
                Start: {moment(event.start).format("DD.MM.YYYY HH:mm")} | End:{" "}
                {moment(event.end).format("DD.MM.YYYY HH:mm")}
              </Typography>
              <Typography>{event.description}</Typography>
            </Box>
          </Box>

          <Divider />

          {isUserParticipant() && (
            <div className="content-container">
              <div>
                <Grid container spacing={3}>
                  {ranking && users && (
                    <Grid key="ranking" xs={12} sm={6} md={4}>
                      <RankingCard ranking={ranking} users={users} />
                    </Grid>
                  )}
                  {tournaments.length > 0 &&
                    tournaments.map((tournament) => (
                      <Grid key={tournament.id} xs={12} sm={6} md={4}>
                        <TournamentCard
                          tournament={tournament}
                          refresh={setRefreshDashboard}
                        />
                      </Grid>
                    ))}
                  {gathers.length > 0 &&
                    gathers.map((gather) => (
                      <Grid key={gather.id} xs={12} sm={6} md={4}>
                        <GatherCard gather={gather} />
                      </Grid>
                    ))}
                  {openOrders && openOrders.length > 0 && (
                    <Grid key="openOrdersCard" xs={12} sm={6} md={4}>
                      <OrderOverviewCard orders={openOrders} />
                    </Grid>
                  )}
                  {polls.length > 0 &&
                    polls.map((poll) => (
                      <Grid key={poll.id} xs={12} sm={6} md={4}>
                        <PollCard poll={poll} />
                      </Grid>
                    ))}
                </Grid>
              </div>

              <Divider />

              <div>
                <Typography variant="h4" gutterBottom>
                  Participants
                </Typography>
                <Grid container spacing={1}>
                  {users.length > 0 &&
                    users.map((user) => (
                      <Grid
                        key={user.nickname}
                        xs={12}
                        sm={6}
                        md={4}
                        onClick={(e) => handleKick(e, user.id)}
                      >
                        <UserCard user={user} />
                      </Grid>
                    ))}
                </Grid>
              </div>

              <Divider />

              <Links />
            </div>
          )}

          {!isUserParticipant() && (
            <div>
              <Button variant="contained" onClick={handleJoin}>
                Join!
              </Button>
            </div>
          )}
        </Box>
      )}
      {!event && <div>No active Event!</div>}
      <Box component="footer" py={2}>
        <div>
          <Typography variant="overline">powered by</Typography>
        </div>
        <div>
          <img
            width="50px"
            height="auto"
            src={emkay}
            alt="logo"
            loading="lazy"
          />
          <img
            width="50px"
            height="auto"
            src={replugged}
            alt="logo"
            loading="lazy"
          />
        </div>
      </Box>
    </Box>
  );
};

export default DashboardPage;
